"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Copyright (C) 2017, Oracle and/or its affiliates. All rights reserved.
 */
var React = require("react");
var util_1 = require("../utils/util");
var warning_1 = require("../utils/warning");
/**
 * OUI icon component.
 *
 * @oui-component Icon
 */
var Icon = function (_a) {
    var icon = _a.icon, ratio = _a.ratio, testId = _a.testId, ariaLabel = _a.ariaLabel, label = _a.label, rest = __rest(_a, ["icon", "ratio", "testId", "ariaLabel", "label"]);
    warning_1.default(ariaLabel !== undefined && label === undefined, "`ariaLabel` is being deprecated, use `label` instead");
    var spanProps = __assign({}, rest, util_1.ariaProps({ label: label || ariaLabel }), { "data-oui-icon": ratio ? "icon: " + icon + "; ratio: " + ratio : "icon: " + icon });
    return React.createElement("span", __assign({}, spanProps, { "data-test-id": testId }));
};
exports.default = Icon;
//# sourceMappingURL=Icon.js.map